<template>
  <v-app>
    <v-content>

      <router-view/>
      <router-link v-if="getFooter" to="/datasecurity" style="z-index: 100; position: absolute; bottom: 10px; left: 20px;">
        <span style="color: var(--mainColor);">{{getText.datasecurityLink}}</span>
      </router-link>
      <router-link v-if="getFooter" to="/impressum" style="z-index: 100; position: absolute; bottom: 10px; left: 220px;">
        <span style="color: var(--mainColor);">{{getText.imprint}}</span>
      </router-link>
    </v-content>
  </v-app>
</template>

<script>
// import Navigation from '@/components/Navigation.vue'

  export default {
    name: 'App',
    components: {
      // Navigation,
    },
    data() {
      return{
      }
     },
     mounted (){
       if(this.deviceIsVertical()){
         this.windowLoadedVertical = true
       }
       this.$store.dispatch("getOrderID");
       this.$store.dispatch("setBenchPlanks");
       this.$store.dispatch("setShelfPlanks");
       this.$store.dispatch("setStoolPlanks");
       this.$store.dispatch("setTablePlanks");
       this.$store.dispatch("setTableOfficePlanks");
     },
     created() {
       window.addEventListener('resize', this.checkOrientation);
       if (this.isMobile()) {
         this.$store.dispatch("setAnimationProperties", 'mobile')
         // this.$router.push('/configuratorTableMobile');
       }
       else {
         this.$store.dispatch("setAnimationProperties", 'desktop')
       }
     },
     destroyed () {
       window.removeEventListener('resize', this.checkOrientation);
     },
     methods: {
         isMobile() {
             if( window.screen.width <= 812 ) {
                 return true;
             }
             else {
                 return false;
             }
         },
         deviceIsVertical(){
           if(window.innerHeight > window.innerWidth && this.isMobile()) {
             return true
           } else {
             return false
           }
         },
         checkOrientation() {
           if(!this.deviceIsVertical()){
             // this.showModal('horizontalWarning')
             this.$store.dispatch("setAnimationProperties", {change: 'verticalOrientation', value: false})
           } else {
             // this.hide('horizontalWarning')
             this.$store.dispatch("setAnimationProperties", {change: 'verticalOrientation', value: true})
           }
           if(!this.windowLoadedVertical && this.deviceIsVertical()){
             this.windowLoadedVertical = true
             this.$router.go()
           }
         },
     },
     computed: {
       getText(){
         return this.$store.getters.getText
       },
       getFooter(){return this.$store.getters.getFooter;},
     },
  }
  </script>

<style scoped>
</style>

<style lang="scss">
.infoChipDesktop{
  width: 300px;
  height: 80px;
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 15;
  padding: 18px;
  background-color: var(--accentColor);
  color: var(--mainColor);
  text-align: center;
  border-radius: 15px;
}
.infoChipMobile{
  width: 250px;
  height: 60px;
  position: absolute;
  top: 15px;
  right: 12px;
  z-index: 15;
  padding: 5px;
  background-color: var(--accentColor);
  color: var(--mainColor);
  text-align: center;
  border-radius: 10px;
}
  .v-btn{
    text-transform: none !important;
  }
  .v-btn--outlined, .v-btn--flat, .v-btn--text{
    background-color: var(--accentColor) !important;
  }
  .theme--dark.v-btn.v-btn--icon {
    color: var(--mainColor) !important;
  }
    #navigation{
      position: fixed;
      top:0;
      width: 100vw;
      height:var(--desktopNavigationHeight);
      max-height:var(--desktopNavigationHeight);
      z-index:50;
    }
  body{
    margin:0 !important;
  }

div{
  /* border: dashed black 0.1px; */
  box-sizing: border-box;
}
img{
  object-fit: cover;
}

/* VIEW TYPES */
.fullWidthElement{
  width:100%;
}
.centerElement{
  width:100%;
  display: grid;
  grid-template-columns: 1fr var(--widthCenterElement) 1fr;
}
.centerElementBig{
  width:100%;
  display: grid;
  grid-template-columns: var(--widthSidesBigCenterElement) 1fr var(--widthSidesBigCenterElement);
}
.leftRightElement{
  width:100%;
  position: relative;
  display: grid;
  grid-template-columns: 50% 50%;
}
.insideLeftElement{
  width: 100%;
  display: grid;
  grid-template-columns: 1fr var(--widthInsideLeftRightElement);
}
.insideRightElement{
  width: 100%;
  display: grid;
  grid-template-columns: var(--widthInsideLeftRightElement) 1fr;
}
.configuratorDesktop{
  width:100%;
  position: relative;
  /* display: grid;
  grid-template-columns: 1fr var(--configuratorDesktopWidthOfSelector); */
  height: calc(90vh - var(--desktopNavigationHeight));
  /* border-bottom: solid 5px var(--accentColorShaded); */
  box-shadow: 0px 2px 4px -1px var(--accentColorShaded), 0px 4px 5px 0px var(--accentColorShaded), 0px 1px 10px 0px var(--accentColorShaded);
}
.configuratorDesktopRows{
  width: 100%;
  position: relative;
  display: grid;
  grid-template-rows: 1fr 120px;
  height: 100%;
}
.configuratorDesktopSelectionRows{
  padding: 20px;
  width: 100%;
  position: relative;
  display: grid;
  grid-template-rows: 40px 80px 1fr;
  min-height: 100%;
}
.v-application a {
    color: var(--accentColor) !important;
}
.accentColorShadedBackground{
  background-color: var(--accentColorShadedTransparent);
  padding: 20px 0;
}

/* ANIMATION STUFF */
.slideELement{
  min-height: calc(100vh - var(--desktopNavigationHeight));
}
.slidePicture{
  height: calc(100vh - var(--desktopNavigationHeight));
}
.stickyAnimation{
  position:sticky;
  top: var(--desktopNavigationHeight);
}
.inFromLeft{
  position: absolute;
  left: -100%;
  width: 100%;
}
.inFromRight{
  position: absolute;
  left: 100%;
  width: 100%;
}
.animationSlidein {
  animation: slidein 2s forwards;
}
@keyframes slidein {
  100% { left: 0; }
}

@import url('https://fonts.googleapis.com/css?family=Mina|PT+Sans');




#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  top: var(--desktopNavigationHeight);
}
button{
  font-family: 'PT Sans';
}

.v-label{
  font-family: 'PT Sans' !important;
  color: var(--mainColor) !important;
}
.theme--light.v-subheader{
  font-family: 'PT Sans' !important;
  color: var(--mainColor) !important;
}

h1{
  font-family: 'Futura';
  font-size: 25px !important;
  font-weight: 400 !important;
  letter-spacing: 0.4px !important;
}

h2{
  font-family: 'Futura';
  font-size: 20px !important;
  font-weight: 400 !important
}

h3{
  font-family: 'PT Sans';
  font-size: 18px !important;
  letter-spacing: 0.3px !important;
  line-height: 1.4;
  font-weight: 400 !important;
  padding: 0
}
.textBlock{
  hyphens: auto;
  text-align: justify;
  }
p{
  font-family: 'PT Sans';
  font-size: 16px !important;
  letter-spacing: 0.2px !important;
  font-weight: 400 !important;
  line-height: 1.75 !important;
}
input {
  font-family: 'PT Sans' !important;
}
label {
  font-family: 'PT Sans' !important;
}
.mobileTextPadding{
  padding: 0 12px;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.v-input.v-color-picker__alpha.v-input--hide-details.v-input--is-label-active.v-input--is-dirty.theme--light.v-input__slider.v-color-picker__track{
visibility: hidden !important;
}
</style>
